import React from 'react';
import {
  FDStack, FDBodyText, FDBox, FDIcon,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import HouseholdCurrentState
  from 'Views/Page/Content/Templates/TransitionsDashboardPage/HouseholdCurrentStates/HouseholdCurrentState';

const HouseholdCurrentStates = ({ collection }) => {
  if (collection?.resources()?.length() === 0) {
    return (
      <FDBox padding={400}>
        <FDStack direction="row" alignItems={'center'} justifyContent={'center'} spacing={1} wrap>
          <FDIcon icon={'check'} />
          <FDBodyText value={'No items to display'} />
        </FDStack>
      </FDBox>
    );
  }

  return (
    <FDStack direction="column" spacing={2}>
      <FDBox>
        {collection.resources().list().map((resource) => {
          return (
            <HouseholdCurrentState resource={resource} />
          );
        })}
      </FDBox>
    </FDStack>
  );
};

HouseholdCurrentStates.defaultProps = {};
HouseholdCurrentStates.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default HouseholdCurrentStates;
